module.exports = __webpack_public_path__ + "static/overlap-60c6acca69956b3e69fc670aa1be10dd.png";